<template>
    <div class="card">
        <div class="card-header">
            {{ title }}
        </div>
        <div class="card-body">
            <div class="desktop">
                <div class="row">
                    <div class="col-xs-6">
                        <div class="centered" >
                            Windows
                        </div>
                        <div class="centered os-icon">
                            <img src="@/assets/img/windows.png" class="os-icon" />
                        </div>
                        <div>
                            <a xmlns="http://www.w3.org/1999/xhtml" class="button-game shop-modal-hide" :href="urls.winPatcher">
                                <span class="button-game-bg-left"></span>
                                <span class="button-game-bg-mid">
                                    <span>Download</span>
                                </span>
                                <span class="button-game-bg-right"></span>
                            </a>
                        </div>
                        <div v-if="fullpatcher" style="text-align: center;" ><a href="#" class="troubleText" @click="openDDModal()" >Having Installer Trouble?</a></div>
                    </div>
                    <div class="col-xs-6">
                        <div class="centered" >
                            Mac
                        </div>
                        <div class="centered os-icon">
                            <img src="@/assets/img/osx.png" class="os-icon" />
                        </div>
                        <div>
                            <a xmlns="http://www.w3.org/1999/xhtml" class="button-game shop-modal-hide" :href="urls.macPatcher">
                                <span class="button-game-bg-left"></span>
                                <span class="button-game-bg-mid">
                                    <span>Download</span>
                                </span>
                                <span class="button-game-bg-right"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile">
                <div class="space-below"><a xmlns="http://www.w3.org/1999/xhtml" class="outline-btn" style="width: 350px;" :href="urls.winPatcher">Windows Download</a></div>
                <div class="space-below"><a xmlns="http://www.w3.org/1999/xhtml" class="outline-btn" style="width: 350px;" :href="urls.macPatcher">Mac Download</a></div>
            </div>
        </div>
        <b-modal ref="dd-modal" hide-footer hide-header centered content-class="modal-content">
            <span class="Video-border Video-border--top"></span>
            <span class="Video-border Video-border--right"></span>
            <span class="Video-border Video-border--bottom"></span>
            <span class="Video-border Video-border--left"></span>
            <span class="Video-corner Video-corner--topLeft"></span>
            <span class="Video-corner Video-corner--topRight"></span>
            <span class="Video-corner Video-corner--bottomRight"></span>
            <span class="Video-corner Video-corner--bottomLeft"></span>
            <div class="modal-header pattern">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeDDModal"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="myModalLabel">Installer Trouble?</h4>
            </div>
            <div class="modal-body pattern-dark clearfix" id="modalBody">
                <div style="color: #fffcd9; font-family: Arial, Helvetica, sans-serif; padding: 16px;">
                    <p>Sometimes the installer has some trouble.</p>
                    <p style="text-align: left;">If you have issues installing Embers adrift you can download the patcher as a zip file by clicking the button below.</p>
                    <p style="text-align: left;">After downloading you can unzip it somewhere on your pc anywhere you have full access and run the file:</p>
                    <p style="font-style: italic;">"Embers Adrift Launcher.exe"</p>
                    <p style="padding-top: 24px;">If you still have issues Let us know on the forums!</p>
                </div>
            </div>
            <div class="modal-footer pattern">
                <div><button @click.prevent="downloadPatcher()" class="outline-btn">Download Full Client</button> </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Downloads'
        },
        fullpatcher: {
            type: String,
            default: ''
        },
        urls: {
            type: Object,
            default () {
                return {
                    winPatcher: '',
                    macPatcher: '',
                    nixPatcher: ''
                }
            }
        }  
    },
    methods: {
        openDDModal() {
            this.$refs['dd-modal'].show();
        },
        closeDDModal() {
            this.$refs['dd-modal'].hide();
        },
        downloadPatcher() {
            window.open(this.fullpatcher);
        }
    } 
}
</script>